import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import AnalysisModule from '../components/AnalysisModule';
import RimlandMap from '../components/RimlandMap';
import History from '../components/History';
import { initFirebase, saveAnalysis, subscribeToHistory } from '../firebase';

const Rimland2 = () => {
  const [userId, setUserId] = useState(null);
  const [authStatus, setAuthStatus] = useState('Cargando autenticación...');
  const [analyses, setAnalyses] = useState([]);

  useEffect(() => {
    const init = async () => {
      const uid = await initFirebase();
      if (uid) {
        setUserId(uid);
        setAuthStatus(`✅ Conectado`);
        
        const unsubscribe = subscribeToHistory(uid, (data) => {
          setAnalyses(data);
        });
        
        return () => unsubscribe();
      } else {
        setAuthStatus('⚠️ No hay usuario autenticado');
      }
    };
    
    init();
  }, []);

  const handleSave = (query, result, type) => {
    if (userId) {
      saveAnalysis(userId, query, result, type);
    }
  };

  return (
    <div className="container">
      <Header 
        title="Rimland - Parte 2" 
        subtitle="Estrategias de Contención"
        authStatus={authStatus}
      />

      <section className="card" style={{ marginBottom: '2rem', textAlign: 'center' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#004e92', marginBottom: '1rem' }}>
          La Doctrina de Contención
        </h2>
        <p style={{ lineHeight: '1.7', maxWidth: '800px', margin: '0 auto' }}>
          La teoría del Rimland de Spykman se convirtió en la base de la política exterior estadounidense durante la Guerra Fría, conocida como la "Doctrina de Contención".
        </p>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', textAlign: 'center', marginBottom: '2rem', color: '#004e92' }}>
          Aplicación Práctica del Rimland
        </h3>
        <div className="grid">
          <div className="card" style={{ borderTop: '4px solid #3b82f6' }}>
            <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '1rem', color: '#3b82f6' }}>
              🛡️ Estrategia de Contención
            </h3>
            <p style={{ lineHeight: '1.7', marginBottom: '1rem' }}>
              George Kennan y los estrategas estadounidenses adoptaron la visión de Spykman:
            </p>
            <ul style={{ marginLeft: '1.5rem', lineHeight: '1.8' }}>
              <li><strong>Objetivo:</strong> Evitar que la URSS controlara el Rimland</li>
              <li><strong>Método:</strong> Crear alianzas en las zonas costeras de Eurasia</li>
              <li><strong>Resultado:</strong> Cerco estratégico al Heartland soviético</li>
            </ul>
          </div>

          <div className="card" style={{ borderTop: '4px solid #8b5cf6' }}>
            <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '1rem', color: '#8b5cf6' }}>
              🌍 Alianzas del Rimland
            </h3>
            <p style={{ lineHeight: '1.7', marginBottom: '1rem' }}>
              EE.UU. construyó una red de alianzas alrededor del Heartland:
            </p>
            <ul style={{ marginLeft: '1.5rem', lineHeight: '1.8' }}>
              <li><strong>OTAN (1949):</strong> Europa Occidental</li>
              <li><strong>SEATO (1954):</strong> Sudeste Asiático</li>
              <li><strong>CENTO (1955):</strong> Medio Oriente</li>
              <li><strong>Alianzas bilaterales:</strong> Japón, Corea del Sur, Taiwán</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="card" style={{ marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', textAlign: 'center', marginBottom: '1rem', color: '#004e92' }}>
          🗺️ Mapa de la Estrategia de Contención
        </h2>
        <p style={{ textAlign: 'center', marginBottom: '1.5rem', color: '#cbd5e1' }}>
          Visualización de cómo EE.UU. rodeó al Heartland soviético con alianzas en el Rimland durante la Guerra Fría.
        </p>
        <RimlandMap />
        <p style={{ textAlign: 'center', marginTop: '1rem', fontSize: '0.9rem', color: '#94a3b8', fontStyle: 'italic' }}>
          💡 Los puntos rojos muestran ciudades estratégicas clave
        </p>
      </section>

      <section className="card" style={{ marginBottom: '2rem' }}>
        <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '1rem', color: '#004e92', textAlign: 'center' }}>
          🗺️ El Anillo de Contención (Conceptual)
        </h3>
        <div style={{ 
          padding: '2rem', 
          backgroundColor: 'rgba(59, 130, 246, 0.1)', 
          borderRadius: '1rem',
          border: '2px solid rgba(59, 130, 246, 0.3)'
        }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
            <div style={{ padding: '1rem', backgroundColor: 'rgba(59, 130, 246, 0.2)', borderRadius: '0.5rem', textAlign: 'center' }}>
              <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>🇪🇺</div>
              <p style={{ fontWeight: 'bold', color: '#3b82f6' }}>Europa Occidental</p>
              <p style={{ fontSize: '0.85rem' }}>OTAN, Plan Marshall</p>
            </div>
            <div style={{ padding: '1rem', backgroundColor: 'rgba(234, 179, 8, 0.2)', borderRadius: '0.5rem', textAlign: 'center' }}>
              <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>🕌</div>
              <p style={{ fontWeight: 'bold', color: '#eab308' }}>Medio Oriente</p>
              <p style={{ fontSize: '0.85rem' }}>Turquía, Irán, Arabia Saudita</p>
            </div>
            <div style={{ padding: '1rem', backgroundColor: 'rgba(139, 92, 246, 0.2)', borderRadius: '0.5rem', textAlign: 'center' }}>
              <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>🇮🇳</div>
              <p style={{ fontWeight: 'bold', color: '#8b5cf6' }}>Asia del Sur</p>
              <p style={{ fontSize: '0.85rem' }}>India, Pakistán</p>
            </div>
            <div style={{ padding: '1rem', backgroundColor: 'rgba(239, 68, 68, 0.2)', borderRadius: '0.5rem', textAlign: 'center' }}>
              <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>🇯🇵</div>
              <p style={{ fontWeight: 'bold', color: '#ef4444' }}>Asia Oriental</p>
              <p style={{ fontSize: '0.85rem' }}>Japón, Corea del Sur, Taiwán</p>
            </div>
          </div>
          <p style={{ textAlign: 'center', marginTop: '1.5rem', fontStyle: 'italic', color: '#94a3b8' }}>
            Este "anillo" de alianzas rodeó al Heartland soviético, impidiendo su expansión hacia las zonas costeras.
          </p>
        </div>
      </section>

      <section className="card" style={{ marginBottom: '2rem' }}>
        <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '1rem', color: '#004e92', textAlign: 'center' }}>
          ✅ Éxito de la Estrategia del Rimland
        </h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1rem' }}>
          <div style={{ padding: '1rem', backgroundColor: 'rgba(34, 197, 94, 0.1)', borderRadius: '0.5rem', borderLeft: '4px solid #22c55e' }}>
            <p style={{ fontWeight: 'bold', color: '#22c55e', marginBottom: '0.5rem' }}>✓ Contención Exitosa</p>
            <p style={{ fontSize: '0.9rem' }}>La URSS nunca logró controlar el Rimland europeo o asiático</p>
          </div>
          <div style={{ padding: '1rem', backgroundColor: 'rgba(34, 197, 94, 0.1)', borderRadius: '0.5rem', borderLeft: '4px solid #22c55e' }}>
            <p style={{ fontWeight: 'bold', color: '#22c55e', marginBottom: '0.5rem' }}>✓ Colapso Soviético</p>
            <p style={{ fontSize: '0.9rem' }}>En 1991, la URSS colapsó sin lograr romper el cerco del Rimland</p>
          </div>
          <div style={{ padding: '1rem', backgroundColor: 'rgba(34, 197, 94, 0.1)', borderRadius: '0.5rem', borderLeft: '4px solid #22c55e' }}>
            <p style={{ fontWeight: 'bold', color: '#22c55e', marginBottom: '0.5rem' }}>✓ Validación de Spykman</p>
            <p style={{ fontSize: '0.9rem' }}>La teoría del Rimland demostró ser más efectiva que la del Heartland</p>
          </div>
        </div>
      </section>

      <AnalysisModule
        title="✨ Análisis de Contención"
        description="Analice una estrategia de contención geopolítica."
        inputType="textarea"
        systemPrompt="Actúa como un estratega de política exterior. Analiza la estrategia de contención proporcionada usando la Teoría del Rimland de Spykman. Explica cómo el control de las zonas costeras de Eurasia es crucial para prevenir la hegemonía de una potencia terrestre. Responde en español de forma concisa."
        onSave={handleSave}
        type="section"
      />

      <History analyses={analyses} />

      <div style={{ position: 'fixed', bottom: '20px', right: '20px', display: 'flex', gap: '10px', zIndex: 1000 }}>
        <Link to="/spykman" className="btn btn-primary" style={{ textDecoration: 'none' }}>
          ⬅️ Anterior
        </Link>
        <Link to="/" className="btn btn-primary" style={{ textDecoration: 'none' }}>
          🏠 Inicio
        </Link>
        <Link to="/heartland-leaflet" className="btn btn-primary" style={{ textDecoration: 'none' }}>
          Siguiente ➡️
        </Link>
      </div>
    </div>
  );
};

export default Rimland2;
